import { Analysis } from '../../types';
import { ConversationMessage } from '../../utils/api';

/** A conversation = every analysis that shares a conversation_id, plus
    (once opened) the merged chat/analysis timeline. Used by both
    My Analyses and Community so the two pages render identically. */
export interface ConversationGroup {
  conversation_id: string;
  analyses: Analysis[];
  first_query: string;
  location: string;
  created_at: string;
  count: number;
  /** Public author label (community only). */
  user_name?: string | null;
  timeline?: TimelineItem[];
}

export interface TimelineItem {
  type: 'message' | 'analysis';
  role?: string;
  content?: string;
  message_type?: string;
  timestamp: Date;
  [key: string]: any;
}

/** Merge chat messages and analysis records into one chronological list. */
export const buildTimeline = (messages: ConversationMessage[], analyses: Analysis[]): TimelineItem[] => {
  const timeline: TimelineItem[] = [];
  messages.forEach(msg => {
    timeline.push({
      type: 'message',
      role: msg.role,
      content: msg.content,
      message_type: msg.message_type,
      timestamp: new Date(msg.created_at),
    });
  });
  analyses.forEach(analysis => {
    timeline.push({ type: 'analysis', ...analysis, timestamp: new Date(analysis.created_at) });
  });
  timeline.sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());
  return timeline;
};
